import axios from 'axios'
import { IReferralSourceDTO } from 'src/viewModels/referrals/ReferralSourceDTO'
import { IReferralSourceSummary } from 'src/viewModels/referrals/ReferralSourceSummary'
import { IReferralSpecialitySummary } from 'src/viewModels/referrals/ReferralSpecialitySummary'
import { ISearchRequestBase } from 'src/viewModels/SearchRequestBase'
import { pagedList } from 'src/viewModels/pagedList'
import { AdvancedSearchConfigurationDTO } from 'src/viewModels/AdvancedSearchConfigurationDTO'
import { ReferralSourceContactDTO } from 'src/viewModels/ReferralSourceContactDTO'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

export async function getReferralSourceSpecialties(
  referralSpeciality: string | null,
  page: number,
  pageSize: number
): Promise<{
  items: IReferralSpecialitySummary[]
  totalItems: number
  totalPages: number
}> {
  const response = await axios.post<{
    items: IReferralSpecialitySummary[]
    totalItems: number
    totalPages: number
  }>(
    `${base_url}/api/admin/referral-source-specialities`,
    {
      referralSpeciality,
      page,
      pageSize,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export const addReferralSourceSpeciality = async (newSpeciality: string) => {
  const response = await axios.post(
    `${base_url}/api/admin/referral-source-speciality`,
    newSpeciality,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export async function searchReferralSource(
  referralSpeciality: string | null,
  inActive: boolean,
  sourceName: string | null,
  page: number,
  pageSize: number
): Promise<{
  items: IReferralSourceSummary[]
  totalItems: number
  totalPages: number
}> {
  const response = await axios.post<{
    items: IReferralSourceSummary[]
    totalItems: number
    totalPages: number
  }>(
    `${base_url}/api/admin/search-referral-source`,
    {
      referralSpeciality,
      inActive,
      sourceName,
      page,
      pageSize,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export const addReferralSource = async (referralSourceDTO: IReferralSourceDTO) => {
  await axios.post(`${base_url}/api/admin/referral-source`, referralSourceDTO, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const getReferralSource = async (id: number) => {
  const response = await axios.get(`${base_url}/api/admin/referral-source/${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const updateReferralSource = async (rsId: number, data: IReferralSourceDTO) => {
  const response = await axios.put(`${base_url}/api/admin/referral-source/${rsId}`, data)
  return response.data
}

export async function getAdvancedReportConfigurations(
  req: ISearchRequestBase
): Promise<pagedList> {
  const response = await axios.post<pagedList>(
    `${base_url}/api/Admin/advanced-search-reports`,
    req
  )

  return response.data
}

export async function getAdvancedReportConfigurationById(id: string) {
  const response = await axios.get<AdvancedSearchConfigurationDTO>(
    `${base_url}/api/Admin/advanced-search-report/${id}`
  )
  return response.data
}

export async function saveConfigurationRoles(configId: string, roleIds: string[]) {
  const response = await axios.put<string>(
    `${base_url}/api/Admin/advanced-search-report/${configId}/roles`,
    roleIds
  )
  return response.data
}

export async function getPagedReferralContacts(
  id: string | number,
  page: number,
  pageSize: number
): Promise<{
  items: ReferralSourceContactDTO[]
  totalItems: number
  totalPages: number
}> {
  const response = await axios.post<{
    items: ReferralSourceContactDTO[]
    totalItems: number
    totalPages: number
  }>(
    `${base_url}/api/Admin/referral-source/${id}/contacts`,
    {
      page,
      pageSize,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}
//localhost:5000/api/Admin/referral-source-contact
export async function addReferralSourceContact(
  contact: ReferralSourceContactDTO
): Promise<ReferralSourceContactDTO> {
  const response = await axios.post<ReferralSourceContactDTO>(
    `${base_url}/api/Admin/referral-source-contact`,
    contact,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export async function updateReferralSourceContact(
  rsContactId: string,
  contact: ReferralSourceContactDTO
): Promise<ReferralSourceContactDTO> {
  const response = await axios.put<ReferralSourceContactDTO>(
    `${base_url}/api/Admin/referral-source-contact/${rsContactId}`,
    contact,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export async function unapplyReceivedCheck(id: string): Promise<string> {
  const response = await axios.post<string>(
    `${base_url}/api/Admin/${id}/unapply-received-check`
  )
  return response.data
}

export async function markAsDeletedReceivedCheck(id: string): Promise<string> {
  const response = await axios.post<string>(
    `${base_url}/api/Admin/${id}/mark-received-check-deleted`
  )
  return response.data
}

export async function GetReceivedCheckUnappliedHistoryDetail(
  id: string
): Promise<string> {
  const response = await axios.get<string>(
    `${base_url}/api/Admin/${id}/received-unapplied-history`
  )
  return response.data
}

export async function GetReceivedCheckAppliedFundsDetail(id: string): Promise<string> {
  const response = await axios.get<string>(
    `${base_url}/api/Admin/${id}/received-applied-funds`
  )
  return response.data
}
